import React, {useEffect} from 'react'
import {
  Text,
  Image,
  withSitecoreContext,
  RichText,
  Link,
  isEditorActive,
} from '@sitecore-jss/sitecore-jss-react'

import './index.scss'
import { CardListModel } from './models/CardList.model'
import { CardListProps } from './types/CardList.types'
import { anchorWithId } from '../../helpers/anchorWithId.helper'

const dateFormat = (date) => {
  if (date) {
    const dateString = new Date(date)

    const dateFormat =
      ('0' + dateString.getDate()).slice(-2) +
      '/' +
      ('0' + (dateString.getMonth() + 1)).slice(-2) +
      '/' +
      dateString.getFullYear()
    let dateval = ('0' + dateString.getDate()).slice(-2)
    let monthval = ('0' + (dateString.getMonth() + 1)).slice(-2)
    let yearval = dateString.getFullYear()
    if (dateval == '01' && monthval == '01' && yearval == 1) {
      return ''
    } else {
      return dateFormat
    }
  }
}

const CardList = (props: CardListProps) => {
  const cardListArray = props.fields?.['Cards list']
  const isReadMoreLink = props.params?.['Variation']

  useEffect(() => {
    if (typeof window !== 'undefined' && 'customElements' in window) {
      import('@patternfly/pfe-icon-onhighway/dist/pfe-icon.js');
    }
  }, []);

  return (
    <>
      {props.fields && (
        <div
          className="cardList__wrapper cardList__wrapper--nobrand"
          id={props?.rendering?.uid}
        >
          {(cardListArray ?? []).map((item, i) => (
            <div className="cardList cardList--nobrand" key={i}>
              <div className="cardList_image-wrapper">
                <Image
                  loading="lazy"
                  field={item?.fields?.Image}
                  className={'image--desktop'}
                />
                <Image
                  loading="lazy"
                  field={
                    item?.fields?.ImageMobile ?
                    (Object.keys(item?.fields?.ImageMobile?.value ?? '').length > 0
                      ? item?.fields?.ImageMobile
                      : (item?.fields?.AllowFallbackForMobile?.value ?
                        item?.fields?.Image: undefined)) : undefined
                  }
                  className={'image--mobile'}
                />

                {item?.fields?.Category?.value ? (
                  <RichText
                    field={item?.fields?.Category}
                    className="category_tag"
                    tag="p"
                  />
                ) : null}
              </div>
              <div className="cardList_content cardList__ctn--cardlist">
                <div className="cardList_date_content">
                  {item.fields?.Date?.value &&
                    !item.fields['Hide Date']?.value && (
                      <>
                        {isEditorActive() ? (
                          <Text field={item.fields?.Date} tag="div" />
                        ) : (
                          <Text
                            field={{
                              value: dateFormat(item.fields?.Date?.value),
                            }}
                            tag="span"
                          />
                        )}
                      </>
                    )}

                  <RichText
                    field={item?.fields?.Content}
                    className="cardList__title--cardlist"
                    tag="h3"
                  />
                  <RichText
                    field={item?.fields?.SubContent}
                    className="cardList__text"
                  />
                </div>

                <div className="cardList_cta_wrapper">
                  {item?.fields?.['Primary Link']?.value.href ? (
                    <div className={`cta cta-primary cta-primary-offwhitered`}>
                      {isEditorActive() ? (
                        <div style={{ display: 'flex' }}>
                          <Link
                            field={{
                              ...item?.fields?.['Primary Link'].value,
                              href: anchorWithId(
                                item.fields?.['Primary Link']?.value?.src as string,
                                item.fields?.['Primary Link']?.value?.anchor
                              ),
                            }}
                          />
                          <span className="link-with-arrow link-with-arrow--text">
                            <pfe-icon
                              icon="cnh-arrow-forward"
                              size={'24'}
                              color={'complement'}
                            />
                          </span>
                        </div>
                      ) : (
                        <a
                          style={{ display: 'flex', alignItems: 'center' }}
                          href={anchorWithId(
                            item.fields?.['Primary Link']?.value?.href,
                            item.fields?.['Primary Link']?.value?.anchor
                          )}
                          target={item.fields?.['Primary Link']?.value?.target}
                          rel="noopener noreferrer"
                        >
                          {item.fields?.['Primary Link']?.value?.text}

                          <span className="link-with-arrow link-with-arrow--text">
                            <pfe-icon
                              icon="cnh-arrow-forward"
                              size={'24'}
                              color={'complement'}
                            />
                          </span>
                        </a>
                      )}
                    </div>
                  ) : null}
                  {item.fields?.['Download Link']?.value?.src ? (
                    <a
                      href={anchorWithId(
                        item.fields?.['Download Link']?.value?.src,
                        item.fields?.['Download Link']?.value?.anchor
                      )}
                      className="download-link"
                      download
                    >
                      <Text field={item.fields?.DownloadText} tag="span" />
                      <pfe-icon size={24} icon="cnh-download" />
                    </a>
                  ) : null}
                </div>

                {item?.fields?.['Secondary Link']?.value?.href ? (
                  <div
                    className="cardList_cta_wrapper"
                    style={{ paddingTop: 2 }}
                  >
                    <div className={`cta cta-primary cta-primary-offwhitered`}>
                      {isEditorActive() ? (
                        <div style={{ display: 'flex' }}>
                          <Link
                            field={{
                              ...item?.fields?.['Secondary Link'].value,
                              href: anchorWithId(
                                item.fields?.['Secondary Link']?.value?.src,
                                item.fields?.['Secondary Link']?.value?.anchor
                              ),
                            }}
                          />
                          <span className="link-with-arrow link-with-arrow--text">
                            <pfe-icon
                              icon="cnh-arrow-forward"
                              size={'24'}
                              color={'complement'}
                            />
                          </span>
                        </div>
                      ) : (
                        <a
                          style={{ display: 'flex', alignItems: 'center' }}
                          href={anchorWithId(
                            item.fields?.['Secondary Link']?.value?.href,
                            item.fields?.['Secondary Link']?.value?.anchor
                          )}
                          target={
                            item.fields?.['Secondary Link']?.value?.target
                          }
                          rel="noopener noreferrer"
                        >
                          {item.fields?.['Secondary Link']?.value?.text}

                          <span className="link-with-arrow link-with-arrow--text">
                            <pfe-icon
                              icon="cnh-arrow-forward"
                              size={'24'}
                              color={'complement'}
                            />
                          </span>
                        </a>
                      )}
                    </div>
                  </div>
                ) : null}
              </div>
            </div>
          ))}
        </div>
      )}
    </>
  )
}

export default withSitecoreContext()(CardList)
